module.exports = __webpack_public_path__ + "img/bg-calendar.0e3f48db.png";